import {RecomendatioName} from "@/types";
import RoofsIcon from "@/components/icons/recommendations/roofs-icon.vue";
import WallsIcon from "@/components/icons/recommendations/walls-icon.vue";
import WindowsIcon from "@/components/icons/recommendations/windows-icon.vue";
import HeatingIcon from "@/components/icons/recommendations/heating-icon.vue";
import VentilationIcon from "@/components/icons/recommendations/ventilation-icon.vue";
import RenewablesIcon from "@/components/icons/recommendations/renewables-icon.vue";
import OthersIcon from "@/components/icons/recommendations/others-icon.vue";
import FloorsIcon from "@/components/icons/recommendations/floors-icon.vue";

export function getIconFromCSS(iconName: string) {
    const bodyStyles = window.getComputedStyle(document.documentElement);
    const iconVariable = `--berwow-icon-${iconName}`;
    return bodyStyles.getPropertyValue(iconVariable);
}

export function getIcon(name: RecomendatioName) {
    return getIconFromCSS(getIconName(name));
}

export function getIconName(name: RecomendatioName) {
    return name
        .trim()
        .substring(
            0,
            name.trim().indexOf(" ") !== -1 ? name.trim().indexOf(" ") : undefined
        )
        .toLowerCase();
}

export function getDefaultIcon(name: RecomendatioName) {
    switch (name) {
        case "Roofs":
            return RoofsIcon;
        case "Walls":
            return WallsIcon;
        case "Windows & Doors":
            return WindowsIcon;
        case "Heating & Controls":
            return HeatingIcon;
        case "Ventilation & Air Tightness":
            return VentilationIcon;
        case "Renewables":
            return RenewablesIcon;
        case "Others":
            return OthersIcon;
        case "Floors":
            return FloorsIcon;
    }
}
